import React, { useState } from 'react';

function Chatbot() {
  const [messages, setMessages] = useState([]); //  Example: State to manage messages
  const [input, setInput] = useState(''); //  Example: State to manage input

  const sendMessage = () => {
    if (!input.trim()) return; //  Don't send empty messages

    const userMessage = { text: input, sender: 'user' };
    setMessages([...messages, userMessage]);
    setInput(''); //  Clear the input

    //  *** 1. RETRIEVE THE TOKEN ***
    const token = localStorage.getItem("token"); //  Or your token key
    if (!token) {
      console.error('No token found. User not authenticated?');
      return; //  Or handle this appropriately (e.g., redirect to login)
    }

    //  *** 2. CONSTRUCT THE FETCH REQUEST ***
    fetch('/chatbot', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`, //  *** INCLUDE THE TOKEN ***
      },
      body: JSON.stringify({ message: input }), //  Or your payload
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        //  *** 3. HANDLE THE RESPONSE ***
        console.log('Chatbot response:', data);
        const botMessage = { text: data.response, sender: 'bot' }; //  Or however your response is structured
        setMessages([...messages, botMessage]);
      })
      .catch(error => {
        //  *** 4. HANDLE ERRORS ***
        console.error('Chatbot error:', error);
        //  ... Handle errors (e.g., display an error message to the user) ...
      });
  };

  //  *** 5. RENDER THE CHATBOT UI ***
  return (
    <div>
      {/* Your Chatbot UI (e.g., message display, input field, send button) */}
      <div className="message-list">
        {Array.isArray(messages) && messages.length > 0 ? (
          messages.map((msg, index) => (
            <div key={index} className={`message ${msg.sender}`}>
              {msg.text}
            </div>
          ))
        ) : (
          <div>No messages yet.</div> //  Or a loading indicator
        )}
    </div>
      <div className="input-area">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
        <button onClick={sendMessage}>Send</button>
      </div>
    </div>
  );
}

export default Chatbot;